import { useEffect, useState } from "react";

export const clearCacheData = async () => {
	console.log("Clearing cache");

	if ("caches" in window) {
		const cacheNames = await caches.keys();
		await Promise.all(
			cacheNames.map(async (name) => {
				try {
					await caches.delete(name);
					console.log("Cache deleted:", name);
				} catch (e) {
					console.warn("Failed to delete cache:", name, e);
				}
			})
		);
	}

	try {
		const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
		const { version } = await fetchVersion.json();
		localStorage.setItem("appVersion", version);
	} catch (error) {
		console.error("Error fetching version:", error);
	}

	window.location.reload();
};

export default function ClearCache(props) {
	const { children } = props;
	const [isLatestVersion, setIsLatestVersion] = useState(true);

	useEffect(() => {
		const checkForUpdates = async () => {
			try {
				const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
				const { version } = await fetchVersion.json();
				const storedVersion = localStorage.getItem("appVersion");

				if (storedVersion) {
					if (storedVersion !== version) {
						setIsLatestVersion(false);
					}
				} else {
					localStorage.setItem("appVersion", version);
				}
			} catch (error) {
				console.error("Error checking for updates:", error);
			}
		};

		checkForUpdates();
	}, []);

	return children({ isLatestVersion, emptyCacheStorage: clearCacheData });
}
